import React,{useEffect} from "react";

function ButtonHint({ children }) {
  return <small className="text-muted ml-2 mt-1">{children}</small>;
}

export default ButtonHint;
